const isClient = () => typeof window !== 'undefined'

// To add additional environment variables that need typing see the /types folder in the root of the project
export const getUniversalEnvVariable = <T extends keyof Window['env']>(variableName: T): Window['env'][T] =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  isClient() ? window.env[variableName] : (process.env[variableName] as any)
